export default __webpack_public_path__ + "static/media/link.b0388bf4.svg";